import { render, staticRenderFns } from "./system-message-dialog.vue?vue&type=template&id=28eb4c34"
import script from "./system-message-dialog.vue?vue&type=script&lang=js"
export * from "./system-message-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports